define('features/all-vehicles',[
  'jquery',
  'webStorage',
  'disclaimers',
  'responsive'
], function (
  $,
  WebStorage,
  disclaimers,
  responsive
) {
  var allVehicles = allVehicles || {
    brandData: {},
    init: function () {
      allVehicles.parseData();

      $('.pad-right-2-lgcolor-red')
        .removeClass('pad-right-2-lgcolor-red')
        .addClass('pad-right-2-lg color-red');
      /*
        onVehicleKeyDown = function (event) {
        if (event.keyCode === 13) {
          var $et = $(event.target);
          window.location.href =  $et.parent().attr('href');
          event.preventDefault();
        }
      };
      */
      allVehicles.bind();
    },

    /**
     * Add event listeners
     */
    bind: function () {
      var currentBreakpoint = responsive();
      $(window).on('breakpoint', function () {
        // note: when the very first breakpoint event occurs, breakpoint is set to 'none'
        // this means we cannot invoke allVehicles.parseData() unless it's !== 'none';
        // without this, parseData() is invoked twice, thereby fetching getSeries.json, twice.
        if (currentBreakpoint !== responsive() && currentBreakpoint !== 'none') {
          // process again vehicle data
          allVehicles.parseData(); // will use cached data from the parseData that ran on init. Needed for BP changes
        }

        currentBreakpoint = responsive();
      });
    },
    /**
     * Get vehicle related data and parse the retrieved information from the server
     */
    parseData: function () {
      var page = this.page; // allVehicles.page obj
      var preset = page.dataPreset();

      preset.then(function (vehicles) {
        page.vehicles = vehicles;

        for (var brand in page.vehicles) {
          if (page.vehicles.hasOwnProperty(brand)) {
            // if we have a brand AND data for that brand, proceed with the cached data
            if (allVehicles.brandData[brand] && allVehicles.brandData[brand].data) {
              page.populateData(allVehicles.brandData[brand].data, allVehicles.brandData[brand].brand);

            // else, get that data
            } else {
              allVehicles.brandData[brand] = {};
              // request data
              page.fetchBrandData(brand).then(function (data, brand) {
                // store vehicle data in cache
                allVehicles.brandData[brand] = {
                  data: data,
                  brand: brand
                };

                // set vehicle data
                page.populateData(data, brand);
              });
            }
          }
        }
      });
    },

    page: {
      counter: 0,

      dataPreset: function () {
        var $elements = $('.all-vehicles-item');
        var deferred = $.Deferred();
        var response = {};

        $elements.each(function (i) {
          var $element = $(this);
          var $elementP = $element.parent();
          var brand = $elementP.data('vehicle-brand');
          var code = $elementP.data('vehicle-series');

          if (typeof response[brand] === 'undefined') {
            response[brand] = [];
          }

          response[brand].push({
            $element: $element,
            code: code,
            cityMpg: 0,
            hwyMpg: 0
          });

          if (i === $elements.length - 1) {
            deferred.resolve(response);
          }
        });

        return deferred.promise();
      },

      fetchBrandData: function (brand) {
        var deferred = $.Deferred();
        var localGetSeries = WebStorage.getSessionStorage().getItem('get-series');

        var processData = function (response) {
          var data = [];
          var series = response.seriesDepthOne.series;
          $.each(series, function (i) {
            data.push({
              series_code: this.year + '-' + this.series_code,
              city_mpg: this.city_mpg,
              hwy_mpg: this.hwy_mpg
            });

            if (i === series.length - 1) {
              deferred.resolve(data, brand);
            }
          });
        };

        if (localGetSeries) {
          // console.log('grabbed get-series from session')
          var response = JSON.parse(localGetSeries);
          processData(response);
        } else {
          $.ajax({
            type: 'GET',
            contentType: 'application/json',
            dataType: 'json',
            url: '/BATWS/cls/getSeries.json',
            data: {
              key: 'XLzu5xh4YzCe6LeNpHVG'
            }
          }).done(function (response) {
            // console.log('getSeries.json NOT in session, grab it and save it');
            WebStorage.getSessionStorage().setItem('get-series', JSON.stringify(response));
            processData(response);
          }).fail(function (jqXHR, textStatus, errorThrown) {
            console.error('ERROR (not displaying City/Hwy in vehicle nav)', textStatus, errorThrown);
          });
        }
        return deferred.promise();
      },

      getBrands: function () {
        var page = this; // allVehicles.page obj
        var processData = function (response) {
          var data = [];
          $.each(response.seriesDepthOne.series, function () {
            data.push({
              series_code: this.series_code,
              city_mpg: this.city_mpg,
              hwy_mpg: this.hwy_mpg
            });
          });

          page.vehicles[brand][0].resolve(data);
        };

        for (var brand in page.vehicles) {
          if (page.vehicles.hasOwnProperty(brand)) {
            $.ajax({
              type: 'GET',
              contentType: 'application/json',
              dataType: 'json',
              url: '/BATWS/cls/getSeries.json?&brand=' + brand,
              success: processData
            });
          }
        }
      },

      populateData: function (data, brand) {
        var page = this; // allVehicles.page obj

        $.each(page.vehicles[brand], function () {
          var vehicle = this;
          var $estMpg = vehicle.$element.find('.js-est-mpg');

          $.each(data, function () {
            if (vehicle.code === this.series_code) {
              vehicle.cityMpg = this.city_mpg;
              vehicle.hwyMpg = this.hwy_mpg;

              return false;
            }
          });

          if (vehicle.cityMpg > 0 && vehicle.hwyMpg > 0) {
            $estMpg.text(vehicle.cityMpg + '/' + vehicle.hwyMpg);
          } else {
            $estMpg.parent().empty();
          }
        });
        disclaimers.msrpMpgDigits('#all-vehicles');
        window.bat.util.loader.hideLoader();

        // scroll to deep links
        var hash = window.location.hash;
        if (hash.length > 0) {
          hash = hash.replace('#', '#js-deep-');
          if ($(hash).length > 0) {
            var headerHeight = $('#area-header').outerHeight();
            var top = $(hash).offset().top;
            var logoHeight = $('.site-nav-logo').height() + 15;
            var offset = top - headerHeight - logoHeight;
            $('html, body').animate({
              scrollTop: offset
            }, 500);
          }
        }
      }
    }

  };

  return allVehicles;
});

